export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return '';
    }

    birthdate() {
        return '2999-19-39';
    }
}
